import { useTheme } from '../context/ThemeContext';

const Footer = ({ pathname }) => {
  const theme = useTheme();
  if (pathname === '/') return null;
  return (
    <div className='container-max text-center py-4'>
      <a
        href='https://mobres.com/'
        target={'_blank'}
        className={`${theme.primary.text} text-sm text-decoration-none`}
      >
        Powered by @MobresPos
      </a>
    </div>
  );
};
export default Footer;
